import React from 'react';
interface SectionBadgeProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
}

/** Small uppercase pill that opens each section. */
export function SectionBadge({
  children,
  tone = 'light',
  className = ''
}: SectionBadgeProps) {
  const styles = tone === 'dark' ? 'border-lime/45 bg-lime/12 text-lime' : 'border-ink/25 bg-ink text-lime';
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.18em] ${styles} ${className}`} data-id="element-45" data-mp="1z13fsl5l6h02">
      {children}
    </span>;
}